import { render, staticRenderFns } from "./MaintenanceRequest.vue?vue&type=template&id=b9950868&scoped=true&"
import script from "./MaintenanceRequest.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9950868",
  null
  
)

export default component.exports